import React from "react";
import PathOption from "../PathOption";
import PathOptionGroup from "../PathOptionGroup";

function PathBuilderOptionsHat({ t, options, handleOptionChange, osSelected }) {
  const note = options.buySeedSigner
    ? t("pathBuilder.instructionContent.hatNoteForSourceParts")
    : t("pathBuilder.instructionContent.buyHatNote");

  return (
    <PathOptionGroup
      title={t("pathBuilder.categories.hat")}
      note={note}
      noteOnHover={true}
    >
      <PathOption
        id="buy-hat"
        label={t("pathBuilder.checkboxes.buyHat")}
        checked={options.buyHat}
        onChange={() => handleOptionChange("buyHat")}
        disabled={!osSelected || options.buySeedSigner}
      />
      <PathOption
        id="build-hat"
        label={t("pathBuilder.checkboxes.buildHat")}
        checked={options.buildHat}
        onChange={() => handleOptionChange("buildHat")}
        disabled={!osSelected || options.buySeedSigner}
      />
      <PathOption
        id="integrate-hat"
        label={t("pathBuilder.checkboxes.integrateHat")}
        checked={options.integrateHat}
        onChange={() => handleOptionChange("integrateHat")}
        disabled={!osSelected || options.buySeedSigner}
      />
      <PathOption
        id="print-3d-seedsigner-hat-box"
        label={t("pathBuilder.checkboxes.print3DHatBox")}
        checked={options.print3DSeedSignerHatBox}
        onChange={() => handleOptionChange("print3DSeedSignerHatBox")}
        disabled={!osSelected || options.buySeedSigner}
      />
    </PathOptionGroup>
  );
}

export default PathBuilderOptionsHat;
